import { OrderStatus } from "@/types/enums/OrderStatus"

/**
 * v1 order-status Web Push policy — mirrors the backend `OrderStatusPushPolicy`.
 * The backend decides what is actually sent; this exists only so the storefront does not offer
 * an opt-in on an order that can no longer produce a notification.
 *
 * Cancelled is deliberately NOT a notifiable status in v1.
 */
export const NOTIFIABLE_ORDER_STATUSES: readonly OrderStatus[] = [
  OrderStatus.Confirmed, // 2 — restaurant accepted the order
  OrderStatus.Ready, // 4 — ready for pickup
  OrderStatus.OutForDelivery, // 8 — on the way
]

/** Statuses the order lifecycle never leaves — no further notification is possible. */
const TERMINAL_ORDER_STATUSES: readonly OrderStatus[] = [
  OrderStatus.Delivered,
  OrderStatus.Cancelled,
  OrderStatus.Returned,
  OrderStatus.Refunded,
  OrderStatus.Completed,
]

/**
 * True when a later transition on this order could still notify the customer, so offering
 * "Enable order updates" is meaningful.
 */
export function canReceiveOrderNotifications(status: OrderStatus): boolean {
  return !TERMINAL_ORDER_STATUSES.includes(status)
}
